export default __webpack_public_path__ + "static/media/talent_block.b5214db0.svg";